import { Category, Position } from '../enums/PermissionsEnums.js';

const hasAccess = (permissions,category, position) => {

  return permissions.some(({ permiso, cargo }) => 
    permiso.categoria?.Id.toUpperCase() === category //valido categoria
    && cargo?.Id.toUpperCase() === position //valido cargo
  );
};

/*const hasCareerAccess = (permissions) => {
  if (hasAccess(permissions, Category.CARRERA, Position.DIRECTOR)){
    return true;
  }else{
    return permissions.some(({ permiso, cargo, unidadGestion }) =>
      permiso.categoria?.Id.toUpperCase() === Category.ADMINISTRATIVO 
      && (
        cargo?.Id.toUpperCase() === Position.SECRETARIO_ACADEMICO ||
        cargo?.Id.toUpperCase() === Position.SECRETARIO_ADMINISTRATIVO ||
        cargo?.Id.toUpperCase() === Position.SECRETARIO_TECNICO
      )
      && (unidadGestion === 'C')
    );
  }
}*/

const hasCareerAccess = (permissions) => {
  
  if (hasAccess(permissions, Category.CARRERA, Position.DIRECTOR)) {
    return true;
  }

  return permissions.some(({ permiso, cargo, unidadGestion }) => {
    const categoryId = permiso.categoria?.Id.toUpperCase();
    const cargoId = cargo?.Id.toUpperCase();

    const isAdminWithAccess = 
      categoryId === Category.ADMINISTRATIVO &&
      [Position.SECRETARIO_ACADEMICO, Position.SECRETARIO_ADMINISTRATIVO, Position.SECRETARIO_TECNICO].includes(cargoId) &&
      unidadGestion === 'C';

    // Nuevo: Acceso si tiene categoría CARRERA y unidad de gestión 'C' (sin importar el cargo específico)
    const isCareerWithAccess = 
      categoryId === Category.CARRERA && unidadGestion === 'C';

    return isAdminWithAccess || isCareerWithAccess;
  });
};

const hasFacultyAccess = (permissions) => {
  if ( 
    hasAccess(permissions, Category.FACULTAD, Position.DECANO) || 
    hasAccess(permissions, Category.FACULTAD, Position.VICEDECANO)
  ){
    return true;
  }else if (
    hasAccess(permissions, Category.FACULTAD, Position.SECRETARIO_ACADEMICO) || 
    hasAccess(permissions, Category.FACULTAD, Position.SECRETARIO_ADMINISTRATIVO) ||
    hasAccess(permissions, Category.FACULTAD, Position.SECRETARIO_TECNICO) 
  ){
    return true;
  }

  return false;
}

const isDecano = (permissions) => {
  const allowAccess = ( hasAccess(permissions, Category.FACULTAD, Position.DECANO) || hasAccess(permissions, Category.FACULTAD, Position.VICEDECANO))
  return allowAccess;
}
const isDirector = (permissions) => {
  return hasAccess(permissions, Category.CARRERA, Position.DIRECTOR)
}

const hasVicerrectoriaAccess = (permissions) => {
  return permissions.some(({ permiso, cargo, unidadGestion }) =>
    (
      unidadGestion === 'VA' || 
      unidadGestion === 'VI' || 
      unidadGestion === 'VE' || 
      unidadGestion === 'VGE'||
      unidadGestion === 'R'
    )
  );
};

const getPositionLabel = (permissions) => {
  const categoryPriority = {
    [Category.ADMINISTRADOR]: 1,
    [Category.FACULTAD]: 2,
    [Category.CARRERA]: 3,
  };

  const hierarchy = [
    Position.RECTOR,        
    Position.VICERRECTOR,
    Position.DECANO,
    Position.VICEDECANO,
    [Position.SECRETARIO_ACADEMICO, Position.SECRETARIO_TECNICO, Position.SECRETARIO_ADMINISTRATIVO], 
    Position.DIRECTOR,
    Position.DIRECTOR_OPERATIVO,
    Position.ASESOR,
    Position.DELEGADO_SUPERIOR,
    Position.COORDINADOR,
  ];

  const getRank = (positionId) => {
    const posIdUpper = positionId.toUpperCase();
    for (let i = 0; i < hierarchy.length; i++) {
      const level = hierarchy[i];
      if (Array.isArray(level)) {
        if (level.map(pos => pos.toUpperCase()).includes(posIdUpper)) {
          return i;
        }
      } else {
        if (level.toUpperCase() === posIdUpper) {
          return i;
        }
      }
    }
    return Number.MAX_SAFE_INTEGER;
  };

  let bestCargo = null;
  let bestWeight = Number.MAX_SAFE_INTEGER;
  let firstCargo = null; // Guarda el primer cargo encontrado

  for (const { permiso, cargo } of permissions) {
    if (cargo) {
      if (!firstCargo) {
        firstCargo = cargo; // Guarda el primer cargo disponible
      }

      const permCategory = permiso.categoria;
      const catPriority = categoryPriority[permCategory] || 100;
      const rank = getRank(cargo.Id);
      const weight = catPriority * 100 + rank;

      if (weight < bestWeight) {
        bestWeight = weight;
        bestCargo = cargo;
      }
    }
  }

  return bestCargo ? bestCargo.descripcion : firstCargo ? firstCargo.descripcion : 'Sin cargo';
};


const getAllowedCareers = (permissions) => {
  const uniqueCareers = {};
  
  permissions
    .filter(({ permiso }) => permiso.categoria?.Id.toUpperCase() === Category.CARRERA)
    .forEach(({ permiso }) => {
      if (!uniqueCareers[permiso.EntityId]) {
        uniqueCareers[permiso.EntityId] = {
          value: permiso.EntityId,
          label: permiso.descripcion
        };
      }
    });

  return Object.values(uniqueCareers);
};

const getAllowedFaculties = (permissions) => {
  const uniqueFaculties = {};
  
  permissions
    .filter(({ permiso }) => permiso.categoria?.Id.toUpperCase() === Category.FACULTAD)
    .forEach(({ permiso }) => {
      if (!uniqueFaculties[permiso.EntityId]) {
        uniqueFaculties[permiso.EntityId] = {
          value: permiso.EntityId,
          label: permiso.descripcion
        };
      }
    });

  return Object.values(uniqueFaculties);
};

//V2
const mapPermissionsToSelectOptions = (permissions) => {
  if (!permissions) return [];

  return permissions.map((p) => ({
    value: buildPermissionKey(p),
    label: p.displayName,
  }));
};

const buildPermissionKey = (perm) => {
  return `${perm.cargo?.codigo}_${perm.permiso?.EntityId}_${perm.sede?.codigo}`;
};

const findPermissionByKey = (permissions, key) => {
  return permissions.find((p) => buildPermissionKey(p) === key);
};

const isFacultyUnit = (perm) => {
  return perm?.permiso?.categoria?.Id?.toUpperCase() === Category.FACULTAD;
}

const isCareerUnit = (perm) => {
  return perm?.permiso?.categoria?.Id?.toUpperCase() === Category.CARRERA;
}

const isRectoriaUnit = (perm) => {
  return (
      perm.unidadGestion === 'VA' || 
      perm.unidadGestion === 'VI' || 
      perm.unidadGestion === 'VE' || 
      perm.unidadGestion === 'VGE'||
      perm.unidadGestion === 'R'
    );
};

export { 
  hasFacultyAccess, 
  hasCareerAccess, 
  hasVicerrectoriaAccess, 
  getPositionLabel, 
  getAllowedCareers, 
  getAllowedFaculties, 
  isDecano, 
  isDirector,
  mapPermissionsToSelectOptions,
  buildPermissionKey,
  findPermissionByKey,
  isFacultyUnit,
  isCareerUnit,
  isRectoriaUnit
};
